export enum PLACEMENT {
    top = 'top',
    topLeft = 'topLeft',
    topRight = 'topRight',
    left = 'left',
    leftTop = 'leftTop',
    leftBottom = 'leftBottom',
    bottom = 'bottom',
    bottomLeft = 'bottomLeft',
    bottomRight = 'bottomRight',
    right = 'right',
    rigthTop = 'rightTop',
    rightBottom = 'rightBottom',
}

export const DEFAULT_CONFIG = {
    okText: 'ok',
    cancelText: 'cancel',
    placement: PLACEMENT.top,
};
